import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { SfInvoiceOpportunity } from '@/types';

interface UpcomingChargesCardProps {
  charges: SfInvoiceOpportunity[];
}

function formatDate(dateStr: string): string {
  return new Date(dateStr).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

function formatCurrency(amount: number | null): string {
  if (amount === null) return '-';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
}

export function UpcomingChargesCard({ charges }: UpcomingChargesCardProps) {
  if (charges.length === 0) {
    return (
      <Card>
        <CardHeader className="pb-3">
          <CardTitle className="text-lg">Upcoming Charges</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-gray-500">No upcoming charges</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-lg">Upcoming Charges</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {charges.map((charge) => (
            <div key={charge.id} className="p-3 bg-gray-50 rounded-lg">
              <div className="flex items-center justify-between mb-2">
                <div className="text-xs text-gray-500">
                  Due: {formatDate(charge.close_date)}
                </div>
                <div className="font-semibold text-lg">
                  {formatCurrency(charge.amount)}
                </div>
              </div>
              {charge.line_items && charge.line_items.length > 0 && (
                <div className="space-y-1 pt-2 border-t border-gray-200">
                  {charge.line_items.map((item) => (
                    <div key={item.id} className="flex justify-between text-sm">
                      <span className="text-gray-600">{item.product_name}</span>
                      <span className="font-medium">{formatCurrency(item.amount)}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
